import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ToHttpHeadersService } from '../utils';
import { ToastType } from '@shared/enums';
import { MESSAGES } from '@shared/constants';

@Injectable({
	providedIn: 'root'
})
export class FileService {
	url = `/api/v1`;
	http = inject(HttpClient);
	toHttpHeaders = inject(ToHttpHeadersService);

	upload(id: number, file: File, type: string, microService?: string): Observable<any> {
		const formData: FormData = new FormData();
		formData.append('file', file, file.name);
		return this.http.post<any>(`${this.url}/${microService ?? 'records'}/upload/${type}/${id}`, formData);
	}

	download(fileName: string): Observable<ArrayBuffer> {
		const params = new HttpParams().set('fileName', fileName);
		return this.http.get(`${this.url}/records/upload/download`, {
			params,
			responseType: 'arraybuffer'
		});
	}

	downloadBlob(fileName: string): Observable<Blob> {
		const params = new HttpParams().set('fileName', fileName);
		return this.http.get(`${this.url}/records/upload/download`, {
			params,
			responseType: 'blob'
		});
	}

	getFile(fileName: string, microService?: string): Observable<Blob> {
		const params = new HttpParams().set('fileName', fileName);
		return this.http.get(`${this.url}/${microService ?? 'records'}/upload/download`, { params, responseType: 'blob' });
	}

	getFileFromServices(fileName: string): Observable<Blob> {
		const params = new HttpParams().set('fileName', fileName);
		return this.http.get(`${this.url}/services/file/download`, { params, responseType: 'blob' });
	}

	delete(fileName: string): Observable<any> {
		const params = new HttpParams().set('fileName', fileName);
		return this.http.delete(`${this.url}/records/upload`, { params });
	}

	uploadList(
		type: string,
		id: number,
		payload: { files: File[]; [key: string]: any }
	): Observable<any> {
		const formData: FormData = new FormData();
		Object.keys(payload).forEach((key) => {
			if (key === 'files') {
				const files = payload[key];
				files.forEach((file) => {
					formData.append('files', file);
				});
			} else {
				formData.append(key, payload[key]);
			}
		});

		if (type === 'OFFBOARDING') {
			return this.http.post<any>(
				`${this.url}/records/upload/list/${type}/${id}`,
				formData,
				this.toHttpHeaders.transform(
					ToastType.SUCCESS,
					MESSAGES.SUCCESS_GENERIC.replace('{$1}', 'uploaded').replace('{$2}', 'the files')
				)
			);
		}

		if (type === 'ANNOUNCEMENT') {
			return this.http.post<any>(
				`${this.url}/admin/upload/list/${type}/${id}`,
				formData,
				this.toHttpHeaders.transform(
					ToastType.SUCCESS,
					MESSAGES.SUCCESS_GENERIC.replace('{$1}', 'uploaded').replace('{$2}', 'the files')
				)
			);
		}


		return this.http.post<any>(`${this.url}/records/upload/list/${type}/${id}`, formData);
	}
}
